import { useMutation, useQueryCache } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { removeNotifyContactsFromSubscriptionGroups } from "../../../queries/notify";
import { buildNotifyContactsQueryKey } from "./useInfiniteNotifyContacts";
import { useToasts } from "react-toast-notifications";
import { ToastStatuses } from "../../../components/global_components/Toast";

// Removes multiple Notify Contacts and all subscirber contact methods from multiple subscription groups
export function useNotifyContactsBulkRemovalFromSubscriptionGroups() {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();
  const { addToast } = useToasts();

  const [removeNotifyContactsFromGroupsMutation, { isLoading: isRemoveNotifyContactsFromGroupsLoading }] = useMutation(
    removeNotifyContactsFromSubscriptionGroups(networkHeaders),
    {
      onSuccess: async () => {
        await queryCache.invalidateQueries(buildNotifyContactsQueryKey());
        addToast("Contacts successfully removed from group", { appearance: ToastStatuses.Success, autoDismiss: true });
      },
      onError: () => {
        addToast("Failed to remove contacts from group", { appearance: ToastStatuses.Error, autoDismiss: true });
      },
    },
  );

  const bulkRemoveNotifyContactsFromSubscriptionGroups = async (
    notifyContactIds: number[],
    subscriptionGroupIds: number[],
  ) => {
    return await removeNotifyContactsFromGroupsMutation({
      subscriptionGroupIds,
      notifyContactIds,
    });
  };

  return { bulkRemoveNotifyContactsFromSubscriptionGroups, isRemoveNotifyContactsFromGroupsLoading };
}
